<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!info">
    <tt-card>
        <tt-input-phone ttLabel="phoneno" [ttModel]="info.phoneno" ttReadonly></tt-input-phone>
    </tt-card>

    <tt-list [ttData]="itemsListFindPersons"></tt-list>
</tt-page>
